import { render, staticRenderFns } from "./MobileAppStore.vue?vue&type=template&id=01d803ca"
import script from "./MobileAppStore.vue?vue&type=script&lang=js"
export * from "./MobileAppStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports